import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { PRODUCT_NAME, solutionCycle, solutionSteps } from '../../data/salesContent';
export function SolutionSection() {
  return <section className="border-t border-line bg-canvas px-5 py-20 md:py-28" data-id="element-181" data-mp="161ibkrmotej2">
      <div className="mx-auto max-w-5xl" data-id="element-182" data-mp="1a229vyizyo6s">
        <SectionHeading title="Imaginá tener todo organizado" data-id="element-183" data-mp="19zofzt01zi0t" />
        <ol className="mx-auto mt-14 grid max-w-4xl gap-x-10 md:grid-cols-2" data-id="element-184" data-mp="dcktaoih7hqb">
          {solutionSteps.map((step, i) => <li key={step} className="flex gap-5 border-t border-line py-6" data-id="element-185" data-mp="ibeaos0vvsvr" data-mpi={i}>
              <span className="text-sm font-black tabular-nums text-accent" data-id="element-186" data-mp="mby3jjefcac3">{String(i + 1).padStart(2, '0')}</span>
              <span className="text-lg font-medium leading-snug text-ink md:text-xl" data-id="element-187" data-mp="r3pzk9gcn89m">{step}</span>
            </li>)}
        </ol>
        <p className="mt-16 text-center text-2xl font-black uppercase tracking-tight text-ink md:text-4xl" data-id="element-188" data-mp="3qq64u68r0vfs">
          Eso es <span className="text-accent" data-id="element-189" data-mp="3upn9ixgcpojw">{PRODUCT_NAME}</span>
        </p>
        <ol className="mt-6 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" aria-label="Cómo funciona" data-id="element-190" data-mp="32kehezle3pf4">
          {solutionCycle.map((step, i) => <li key={step} className="flex items-center gap-3 text-lg font-extrabold uppercase tracking-widest text-ink md:text-xl" data-id="element-191" data-mp="2suuyjtxofvk9" data-mpi={i}>
              {step}
              {i < solutionCycle.length - 1 && <ArrowRightIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-192" data-mp="2iwyoz6ke18o9" />}
            </li>)}
        </ol>
      </div>
    </section>;
}